import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { ModeOrder, Store } from 'src/app/core/models/mode-order.model';
import { CONTROL_EVENT } from 'src/app/core/models/events_promotion';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { BpAddressService } from 'src/app/services/bp-address.service';
import { EcommerceService } from 'src/app/services/ecommerce/ecommerce.service';
import { ModeOrderService } from 'src/app/services/ecommerce/mode-order.service';
import { StoreService } from 'src/app/services/ecommerce/store.service';
import { CompanyService } from 'src/app/services/global/company.service';
import { PromotionPageService } from 'src/app/services/promotion-page.service';
import { PROVIDER } from 'src/environments/config';
import { DeliveryAddressComponent } from '../delivery-address/delivery-address.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-order-start',
  templateUrl: './order-start.component.html',
  styleUrl: './order-start.component.scss',
})
export class OrderStartComponent implements OnInit, OnDestroy {
  obs: Subscription[] = [];

  company = null;
  user: any = null;

  // mode: ModeOrder = null
  mode: ModeOrder = new ModeOrder();

  selected = null;
  subSelected = null;

  listAddress: any = [];

  constructor(
    public formBuilder: FormBuilder,
    private companyService: CompanyService,
    public snackBar: MatSnackBar,
    private orderModeService: ModeOrderService,
    private router: Router,
    private ecommerce: EcommerceService,
    public authService: AuthenticationService,
    private storeService: StoreService,
    private matDialogService: MatDialog,
    private addressService: BpAddressService,
    private promotionPageService: PromotionPageService,
    private translate: TranslateService,
    public dialogRef: MatDialogRef<OrderStartComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.obs.push(
      this.companyService.currenCompany.subscribe((res: any) => {
        this.company = res;
      })
    );
    this.obs.push(
      this.authService.currentUser.subscribe((user: any) => {
        if (user == null) {
          this.user = null;
        } else {
          this.user = user.user;
          this.getListAddress();
        }
      })
    );
    this.obs.push(
      this.orderModeService.currentMode.subscribe((res: any) => {
        console.log('res', res);
        this.mode = res;
        if (res == null) {
          this.selected = null;
          let object = new ModeOrder();
          object.orderSelected = 'PD';
          if (this.user) {
            object.addressSelected.name =
              this.user.bp_addressSelected == '0' ||
              this.user.bp_addressSelected == 0
                ? null
                : this.getObjectAddres(this.user.bp_addressSelected)
                ? this.getObjectAddres(this.user.bp_addressSelected).address
                : null;
          }
          // this.ecommerce.resetCart()
          this.orderModeService.updateCurrentModeOrder(object);
        } else {
          this.selected = this.mode.orderSelected;
          if (this.mode.orderSelected == null) {
            let object = new ModeOrder();
            object.orderSelected = 'PD';
            // this.ecommerce.resetCart()
            this.orderModeService.updateCurrentModeOrder(object);
          }
        }
        if (res == null) {
          this.subSelected = null;
        } else {
          this.subSelected = this.mode.subOrderSelected;
        }
        console.log('this.mode', this.mode);
      })
    );
  }

  ngOnInit() {
    this.dialogRef.updateSize('750px');
  }
  setOrderMode(data: any) {
    console.log('data>>', data);
    if (data == 'PD') {
      let object = new ModeOrder();
      object.orderSelected = data;
      object.subOrderSelected = data;
      console.log('object>>', object);
      console.log('user>>', this.user);

      if (this.user) {
        if (this.user.bp_addressSelected == 0 && this.user.bp_address == null) {
          this.openModalAddress();

          this.translate
            .get('TRANSLATE.ENTER_ADDRESS')
            .subscribe((translatedMessage) => {
              this.snackBar.open(translatedMessage, '×', {
                panelClass: 'error',
                verticalPosition: 'top',
                duration: 3000,
              });
            });
        } else {
          this.getStoreDelivery(object);
        }
      } else {
        // this.ecommerce.resetCart()
        this.orderModeService.updateCurrentModeOrder(object);
        this.dialogRef.close();
        //TODO: porsiacaso
        if (this.promotionPageService.isPromocion) {
          this.promotionPageService.onSentAction(
            CONTROL_EVENT.ON_RELOAD_PRODUCT
          );
        }
      }
      if (!this.promotionPageService.isPromocion) {
        this.router.navigate(['/']);
      }
    }
    if (data == 'pickup') {
      // TODO, ABRIR MODAL O NAVEGAR A LA VENTANA DE RESTAURANTE

      this.router.navigate(['/productos']);
      this.dialogRef.close();
    }
  }

  getStoreDelivery(object: any) {
    let send = {
      type: 'PD',
      branch: PROVIDER.providerId, // id->de la marca
      address_type:
        this.user.bp_addressSelected == '0' || this.user.bp_addressSelected == 0
          ? 'bp'
          : 'bpa', //bp-> para direccion principal, bpa -> para direccion secundaria
      address_id:
        this.user.bp_addressSelected == '0' || this.user.bp_addressSelected == 0
          ? this.user.bp_id
          : this.user.bp_addressSelected,
    };
    console.log('gaa send', send);

    this.storeService.getStoreByAddress(send).subscribe((res: any) => {
      console.log('gaaa res', res);
      if (res.response == 'success') {
        let store = res.store;
        if (
          this.mode.storeSelected.id != null &&
          this.mode.storeSelected.id != store.id
        ) {
          // this.ecommerce.resetCart()
        }
        object.storeSelected = store;
        object.addressSelected.name =
          this.user.bp_addressSelected == '0' ||
          this.user.bp_addressSelected == 0
            ? null
            : this.getObjectAddres(this.user.bp_addressSelected)
            ? this.getObjectAddres(this.user.bp_addressSelected).address
            : null;
        this.orderModeService.updateCurrentModeOrder(object);
        // AQUI VALIDO MI SELECCION POR PROMICION
        if (this.promotionPageService.isPromocion) {
          this.dialogRef.close(); // LO QUE DEBE SUCEDER ES VER SI ESTA DISPONIBLE O NO EL PRODUCTO
          //if (this.promotionPageService.isPromocion) {
          this.promotionPageService.onSentAction(
            CONTROL_EVENT.ON_RELOAD_PRODUCT
          );
          //}
        } else {
          console.log('else');
          this.router.navigate(['/productos']);
          this.dialogRef.close();
        }
      } else {
        //solo si hay mas direcciones y dirección principal
        if (this.user.bp_address != null) {
          this.snackBar.open(res.message, '×', {
            panelClass: 'error',
            verticalPosition: 'top',
            duration: 3000,
          });
          this.openModalAddress();
        } else {
          this.snackBar.open(res.message, '×', {
            panelClass: 'error',
            verticalPosition: 'top',
            duration: 3000,
          });
        }
      }
    });
  }

  setSubOrder(data: any) {
    // si selecciono por defecto sera pickup
    //let object = new ModeOrder()

    if (this.promotionPageService.isPromocion) {
      this.dialogRef.close(data);
      return;
    }
    if (this.mode == null) {
      this.mode = new ModeOrder();
    }
    // this.ecommerce.resetCart()
    this.mode.orderSelected = 'pickup';
    this.mode.subOrderSelected = data;
    this.mode.storeSelected = new Store();
    this.orderModeService.updateCurrentModeOrder(this.mode);
    this.dialogRef.close();

    this.router.navigate(['/ubicacion-restaurantes']);
  }

  openModalAddress() {
    //aqui pondre mi validacion para que me abra la direccion desde page si es promocion
    if (this.promotionPageService.isPromocion) {
      this.dialogRef.close();
      this.promotionPageService.onSentAction(CONTROL_EVENT.TO_OPEN_ADDRESS);
      return;
    }

    const dialogRef = this.matDialogService.open(DeliveryAddressComponent, {
      data: null,
      width: '700px',
      disableClose: false,
      //direction: (this.settings.rtl) ? 'rtl' : 'ltr'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result == 'close' || result == undefined) {
      } else {
        if (result == 0 || result == '0') {
          this.user.bp_addressSelected = result;
        } else {
          this.user.bp_addressSelected = result.id;
        }
        this.authService.updateCurrentUser(this.user);

        this.mode.addressSelected.name =
          result == '0' || result == 0 ? null : result.address;
        if (this.mode.orderSelected == 'pickup') {
          this.getStoreDelivery(this.mode);
        } else {
          this.router.navigate(['/']);
          this.dialogRef.close();
        }
      }
    });
  }

  //ADDRESS
  getListAddress() {
    this.addressService.getAddresByBpCb().subscribe(
      (data) => {
        this.listAddress = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getObjectAddres(id: any) {
    return this.listAddress.find((res: any) => res.id == id);
  }

  verifyAddress() {
    if (
      this.mode.orderSelected == 'PD' &&
      this.user.bp_addressSelected == 0 &&
      this.user.bp_address == null
    ) {
      this.translate
        .get('TRANSLATE.ENTER_ADDRESS')
        .subscribe((translatedMessage) => {
          this.snackBar.open(translatedMessage, '×', {
            panelClass: 'error',
            verticalPosition: 'top',
            duration: 3000,
          });
        });

      return;
    }
    //falta verificar cuando es tienda no disponible y no hacer "x"
    this.dialogRef.close();
  }

  getCaracteresText(text: string): string {
    if (text != null) {
      let nt = text;
      let nu = text.length;
      if (nu > 50) {
        return nt.substring(0, 50) + '...';
      } else {
        return nt;
      }
    } else {
      return '';
    }
  }

  // toNavigateMap() {
  //   if (this.promotionPageService.isPromocion) {
  //     this.dialogRef.close()
  //     this.promotionPageService.onSentAction(CONTROL_EVENT.TO_OPEN_PICKUP)
  //     return
  //   }
  //   this.router.navigateByUrl("/ubicacion-restaurantes")
  //   this.dialogRef.close()
  // }
  ngOnDestroy() {
    this.obs.forEach((element) => {
      element.unsubscribe();
    });
  }
}
